import { render, staticRenderFns } from "./NotificationConsultantApprovalRequest.vue?vue&type=template&id=42e10c7d"
import script from "./NotificationConsultantApprovalRequest.vue?vue&type=script&lang=js"
export * from "./NotificationConsultantApprovalRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports